import ApplicationAdapter from 'cio/adapters/application';
import { ModelRegistry } from 'ember-data/model';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import EnvironmentService from 'cio/services/environment';
import ActiveModelAdapter from 'active-model-adapter';

export default class ObjectTypeAdapter extends ApplicationAdapter {
  @service auth!: AuthService;
  @service environment!: EnvironmentService;

  pathForType(modelName: keyof ModelRegistry) {
    let path = ActiveModelAdapter.prototype.pathForType.call(this, modelName);

    let lastEnvId = this.environment.lastEnvironmentId;

    if (lastEnvId != null) {
      let envId = encodeURIComponent(lastEnvId);
      path = `environments/${envId}/${path}`;
    }

    return path;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'object-type': ObjectTypeAdapter;
  }
}
